import React from 'react';

import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import './assets/robotofonts.css';
import './App.scss';
import Home from './containers/Home';
import SignUp from './containers/SignUp';
import RegistrationPage from './containers/Registration';

const App = () => {
  return (
    <Router>
      <div className='App'>
        <Switch>
          <Route exact path='/' component={Home} />
          <Redirect exact from='/ranking' to='/' />
          <Redirect exact from='/login' to='/' />
          {/* <Route path='/sign-up' component={Login} /> */}
          <Route path='/sign-up' component={SignUp} />
          <Route path='/registration' component={RegistrationPage} />
          <Redirect exact from='/edit' to='/' />
          <Redirect from='*' to='/' />
        </Switch>
      </div>
    </Router>
  );
};

export default App;
